/**
 * Keep PDP recommendations aligned with the selected variant without rendering
 * every variant group into the initial document.
 */
(function () {
  var pendingRequests = new Map();

  function getVariantIdFromUrl() {
    try {
      var url = new URL(window.location.href);
      var variantId = url.searchParams.get('variant');

      return variantId && /^\d+$/.test(variantId) ? variantId : null;
    } catch (_) {
      return null;
    }
  }

  function showRenderedItem(root) {
    var item = root && root.querySelector('.featured-collections-carousel__item');
    if (item) item.classList.add('is-shown');
  }

  async function renderVariant(root, variantId) {
    if (!root || !variantId || root.dataset.variantId === variantId) {
      showRenderedItem(root);
      return;
    }

    var sectionId = root.dataset.sectionId;
    var productUrl = root.dataset.productUrl;
    if (!sectionId || !productUrl) return;

    var pending = pendingRequests.get(sectionId);
    if (pending && pending.variantId === variantId) return;
    if (pending) pending.controller.abort();

    var controller = new AbortController();
    pendingRequests.set(sectionId, { controller: controller, variantId: variantId });
    root.setAttribute('aria-busy', 'true');

    try {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);

      var response = await window.fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Recommendation section request failed with status ' + response.status);

      var documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      var nextRoot = documentFragment.querySelector('[data-floyd-recommendations]');
      if (!nextRoot) throw new Error('Recommendation section response is missing its Floyd root');

      showRenderedItem(nextRoot);
      root.replaceWith(nextRoot);
    } catch (error) {
      if (error.name !== 'AbortError') {
        root.removeAttribute('aria-busy');
        console.warn('[FLOYD recommendations]', error);
      }
    } finally {
      var current = pendingRequests.get(sectionId);
      if (current && current.controller === controller) pendingRequests.delete(sectionId);
    }
  }

  function updateRecommendedProducts(scope) {
    var rootScope = scope && scope.querySelectorAll ? scope : document;
    var variantId = getVariantIdFromUrl();

    rootScope.querySelectorAll('[data-floyd-recommendations]').forEach(function (root) {
      renderVariant(root, variantId || root.dataset.variantId);
    });
  }

  function scheduleUpdate() {
    window.setTimeout(function () {
      updateRecommendedProducts(document);
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateRecommendedProducts(document);
    });
  } else {
    updateRecommendedProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    updateRecommendedProducts(event.target);
  });
  document.addEventListener('variant:change', scheduleUpdate);
  document.addEventListener('floyd:recommended-variants:update', scheduleUpdate);
})();
